import React, { useContext, useEffect, useMemo, useState } from "react";
import { useTheme } from "emotion-theming";
import { get } from "../../../logics/src/utils/helpers";
import { PaymentContext } from "wrapper/PaymentWrapper/context/paymentContext";
import { doPaymentHandler } from "layouts/Payment/logics/doPaymentHandler";
import {
  giftCardBalance,
  validateBankCard,
  validateBankCardHash,
  checkSimplEligibility,
  checkZestEligibility,
  getSimplRelinkStatus,
  getPaytmDetails,
  paytmAddMoney,
  paytmRegister,
  paytmValidateOtp,
  paymentMethodOffers,
  validateBankOffer,
  validateCardBin,
  getValidateUPI,
  getGiftCardPurchaseResponse,
  getWalletPaymentResponse,
} from "store/payment/services";
import {
  trackBankCardBinInvalid,
  trackBankCardValidForOffer,
  trackConsentButtonClicked,
  trackDesktopPaymentPageLoad,
  trackPaymentMethodClick,
  trackKnowMoreClicked,
  trackUserConsentChecked,
  trackCodNudgeVisible,
  trackCODNudgeCtaClick,
  trackErrorPageLoad,
  trackPayNowClick,
} from "layouts/Payment/common/dependencies/tracking";
import { OverlayLoader } from "components/OverlayLoader";
import { ErrorModalContext } from "wrapper/ErrorModalWrapper/context";
import { UserContext } from "wrapper/UserWrapper/context";
import { useHistory } from "react-router-dom";
import { ApplicationContext } from "wrapper/ApplicationWrapper/context";
import { VerifyOtpContext } from "wrapper/VerifyOtpWrapper/context";
import { getOrdersPaymentResponse } from "store/payment/services";
import { BagDetails } from "layouts/Auth/desktop/components/BagDetails";
import {
  trackInfoIconClick,
  trackPaymentDetailClick,
} from "layouts/Payment/common/dependencies/tracking";
import SideBarCart from "layouts/Auth/desktop/components/SidebarCart";
import { cartInfoCallback, setCartItems } from "wrapper/PaymentWrapper/dependencies/helper";
import { CLIENT_URLS } from "constants/urls";
import { PAYMENT_ERROR_MESSAGE } from "constants/paymentStatus";
import { PaymentSeo } from "layouts/PaymentSeo";
import { PAYMENT_FLOWS } from "constants/payment";
import { VerifyOTP } from "layouts/VerifyOtp";
import { NOT_AVAILABLE, PAGE_NAMES } from "../../../constants";
import PaymentDesktopView from "./PaymentViewDesktop/index";
import { getStorageData } from "helpers/utils/storage";
import { PAYTM_AUTOPAY } from "constants/cookies";
import { doRedirect } from "helpers/utils/redirection";
import { ExperimentAndSwitchContext } from "wrapper/ExperimentAndSwitchWrapper/context";
import { PAYMENT_MODES } from "constants/paymentModes";


const CheckoutPayment = () => {
  const theme: any = useTheme();
  const history = useHistory();
  const { userData } = useContext(UserContext);
  const { PCI: PciExperiment, ConvenienceCharges } = useContext(ExperimentAndSwitchContext);

  const { isGuest } = userData;
  const errorModalContext = useContext(ErrorModalContext);
  const openErrorModal = get(errorModalContext, "openErrorModal");
  const paymentContext = useContext(PaymentContext);
  const cartInfo = get(paymentContext, "cartInfo");
  const walletInfo = get(paymentContext, "walletInfo");
  const giftCardInfo = get(paymentContext, "giftCardInfo");
  const flow = get(paymentContext, "flow");
  const { applicationData } = useContext(ApplicationContext);
  const { deviceType } = applicationData;
  const paymentInfo = get(paymentContext, "paymentInfo");
  const setLoading = get(paymentContext, "setLoading");
  const setIsPaymentProcessing = get(paymentContext, "setIsPaymentProcessing");
  const loading = get(paymentContext, "loading");
  const grandTotal = get(paymentContext, "cartInfo.grandTotal");
  const customerEmail = get(paymentContext, "cartInfo.customerEmail");
  const walletBalance = get(paymentContext, "walletInfo.balance");
  const contactNumber = get(paymentContext, "walletInfo.contactNumber");
  const doPaymentApi = get(paymentContext, "doPaymentApi");
  const [items, setItems] = useState<any[]>([]);
  const [showCart, setShowCart] = useState(false);
  const setCartInfo = get(paymentContext, "setCartInfo");
  const query = new URLSearchParams(history.location.search);
  const updateCartRules = get(paymentContext, "updateCartRules");
  // configs for managing bagDetails , headers etc
  const isCartRulesLoading = get(paymentContext, "isCartRulesLoading");
  const loaderMessage = get(paymentContext, "loaderMessage");

  const setGiftCardConfig = get(paymentContext, "setGiftCardConfig");

  const isWalletAccordianOpen = get(paymentContext, "isWalletAccordianOpen");
  const setIsWalletAccordianOpen = get(paymentContext, "setIsWalletAccordianOpen");
  const setFinalOrderAmount = get(paymentContext, "setFinalOrderAmount");
  const walletOtpVerificationRequired = paymentContext?.walletOtpVerificationRequired;
  const setIsAutoCreateOrderLoading = get(paymentContext, "setIsAutoCreateOrderLoading");
  const walletConfig = paymentContext?.walletConfig;
  const giftCardConfig = paymentContext?.giftCardInfoConfig;
  const orderAmount = paymentContext?.orderAmount;
  const autoCreateOrder = query.get("autoCreateOrder"); // Getting autoCreateOrder as string from queryParams
  const payTmAutoPay = getStorageData(PAYTM_AUTOPAY, false) || "false"; // Getting payTmAutoPay as string from session storage
  const autoPayTmCreateOrder = autoCreateOrder === "true" && payTmAutoPay === "true";

  const isVerificationRequired = get(walletInfo, "isVerificationRequired"); // for wallet veriffication;

  // callbacks for verifyotp module from context
  const {
    isVerifyOtpVisible,
    setIsVerifyOtpVisible,
    sendOtpCallback,
    verifyOtpCallback,
    handleCallBackAfterVerification,
    isOtpVerificationRequired,
    setIsOtpVerificationRequired,
  } = useContext(VerifyOtpContext);

  const offersData = get(paymentContext, "offersData");
  const flowConfig = get(paymentContext, "flowConfig");
  const { activeMethodForSavedPayments, setActiveMethodForSavedPayments } = paymentContext;


  useEffect(() => {
    const queryMessage = query.get("message");
    const status = query.get("status");
    if (queryMessage) {
      openErrorModal(PAYMENT_ERROR_MESSAGE.FAILED, queryMessage);
      trackErrorPageLoad({
        error_code: NOT_AVAILABLE,
        error_message: queryMessage,
        interaction_location: PAGE_NAMES.PAYMENT_PAGE,
      });
    } else if (status === "failed") {
      openErrorModal(PAYMENT_ERROR_MESSAGE.FAILED, PAYMENT_ERROR_MESSAGE.SOMETHING_WENT_WRONG);
      trackErrorPageLoad({
        error_code: NOT_AVAILABLE,
        error_message: PAYMENT_ERROR_MESSAGE.SOMETHING_WENT_WRONG,
        interaction_location: PAGE_NAMES.PAYMENT_PAGE,
      });
    }
    /* eslint-disable react-hooks/exhaustive-deps */
  }, []);

  useEffect(() => {
    setIsOtpVerificationRequired(walletOtpVerificationRequired || (isWalletAccordianOpen && isVerificationRequired));
   /* eslint-disable react-hooks/exhaustive-deps */
  }, [walletOtpVerificationRequired, isWalletAccordianOpen, isVerificationRequired]);

  const editBag = (e: any) => {
    e?.stopPropagation();
    setShowCart(!showCart);
  };

  // passing extra parameters from context to doPaymentFactory
  const handleDoPaymentFactory = (method: string, params: any) => {
    const requestParams: any = {
      cartInfo,
      paymentInfo,
      isGuest,
      history,
      flow,
      deviceType,
      isOtpVerificationRequired: isOtpVerificationRequired && flow !== PAYMENT_FLOWS.WALLET, // on wallet screen otpVerification is not needed,
      pciEnabled: PciExperiment.experimentEnabled,
      metaDataTags: [],
      applyCartCharges: !!ConvenienceCharges?.experimentEnabled,
    };
    if (flow === PAYMENT_FLOWS.COD_TO_PREPAID) {
      /* eslint-disable no-shadow */
      const query = new URLSearchParams(history.location.search);
      const orderId = query.get("orderId");
      requestParams.orderId = orderId;
    }

    const callbacks = {
      setLoading,
      setIsAutoCreateOrderLoading,
      openErrorModal,
      trackPayNowClick,
      setIsVerifyOtpVisible,
      handleCallBackAfterVerification,
      setIsPaymentProcessing,
      doPaymentApi,
      setCartInfo,
      history,
    };

    // passing orderAmount for wallet flow
    if (flow == PAYMENT_FLOWS.WALLET && method == PAYMENT_MODES.INTENT) {
      params.values = {
        ...params.values,
        grandTotal: orderAmount,
      };
    }

    const configParams = {
      walletConfig,
      giftCardConfig,
      values: params,
    };
    doPaymentHandler(method, configParams, requestParams, callbacks);
  };

  const getCartInfo = async (refreshData: any) => {
    const res: any = await cartInfoCallback(refreshData, true);
    setCartInfo(res);
  };

  useMemo(() => {
    const shippingAddress = cartInfo?.shippingAddress;
    if (cartInfo && customerEmail && !shippingAddress) {
      doRedirect({
        url: CLIENT_URLS.ADDRESS_BASE_URL,
        history,
        isClientRedirection: true,
      });
      return;
    }
    const products = setCartItems(cartInfo.cartItems);
    setItems(products);
  }, [cartInfo]);

  useEffect(() => {
    // This block is to show overlay loader based on isAutoCreateOrderLoading state , when autoPayTmCreateOrder is true.
    if (autoPayTmCreateOrder) {
      setIsAutoCreateOrderLoading(true);
    }

    /**
     * Added for refresh the desktop payment page.
     * It will trigger incase of when user will remove coupon and then click on view bag then
     * coupons page automatically redirects to shoppingBag and there if user click on header back
     * button closeCart event called
     */
    (window as any).closeCart = () => {
      window.location.reload();
    };
  }, []);

  const config = {
    theme,
    flow,
    flowConfig,
    grandTotal,
    walletBalance,
    components: {
      bagComponent: <BagDetails items={items} theme={theme} />,
      SavedPciComponent: <></>,
      NewPciComponent: <></>,
    },
    cartInfo,
    paymentInfo,
    offersData,
    walletInfo,
    giftCardInfo,
    userInfo: {
      mobileNumber: contactNumber,
    },
    callbacks: {
      common: {
        setLoading,
        setIsPaymentProcessing,
        openErrorModal,
      },
      upi: {
        getOrdersPaymentResponse: getOrdersPaymentResponse,
        getGiftCardPurchaseResponse: getGiftCardPurchaseResponse,
        getValidateUPI: getValidateUPI,
        // used for wallet flow in useTimerModal
        getWalletPaymentResponse: getWalletPaymentResponse,
      },
      cc: {
        validateBankCard: validateBankCard,
        validateBankCardHash: validateBankCardHash,
        trackBankCardValidForOffer: trackBankCardValidForOffer,
        trackBankCardBinInvalid: trackBankCardBinInvalid,
        validateCardBin: validateCardBin,
        trackKnowMoreClicked: trackKnowMoreClicked,
        trackConsentButtonClicked: trackConsentButtonClicked,
        trackUserConsentChecked: trackUserConsentChecked,
        setActiveMethodForSavedPayments: setActiveMethodForSavedPayments,
      },
      gift: {
        giftCardBalance: giftCardBalance,
        setGiftCardConfig: setGiftCardConfig,
      },
      snpl: {
        checkSimplEligibility: checkSimplEligibility,
        checkZestEligibility: checkZestEligibility,
        getSimplRelinkStatus: getSimplRelinkStatus,
      },
      paytm: {
        getPaytmDetails: getPaytmDetails,
        paytmAddMoney: paytmAddMoney,
        paytmRegister: paytmRegister,
        paytmValidateOtp: paytmValidateOtp,
      },
      offers: {
        paymentMethodOffers: paymentMethodOffers,
        validateBankOffer: validateBankOffer,
        updateCartRules: updateCartRules,
      },
      priceDetails: {
        trackToggleAccordian: () => {
          trackPaymentDetailClick("payment");
        },
        trackInfoIconClick: (type: string) => {
          trackInfoIconClick("payment", type);
        },
      },
      cart: {
        editBag: editBag,
      },
      analytics: {
        trackDesktopPaymentPageLoad: trackDesktopPaymentPageLoad,
        trackPaymentMethodClick: trackPaymentMethodClick,
      },
      cod: {
        trackCodNudgeVisible: trackCodNudgeVisible,
        trackCODNudgeCtaClick: trackCODNudgeCtaClick,
      },
    },
    doPayment: handleDoPaymentFactory,
    isGuest,
    platform: __PLATFORM__,
    isCartRulesLoading,
    activeMethodForSavedPayments,
    setIsWalletAccordianOpen,
    isWalletAccordianOpen,
    setFinalOrderAmount,
    autoPayTmCreateOrder,
  };


  return (
    <>
      <PaymentSeo
        title={__SEO_TITLE__}
        canonicalLink={__CANONICAL_LINK__}
        description={__SEO_DESCRIPTION__}
        img={__LOGO__}
      />

      <PaymentDesktopView {...config}/>

      {isVerifyOtpVisible && (
        <VerifyOTP
          sendOtpCallback={sendOtpCallback}
          verifyOtpCallback={verifyOtpCallback}
          mobileNumber={contactNumber}
          isVerifyOtpVisible={isVerifyOtpVisible}
          setIsVerifyOtpVisible={setIsVerifyOtpVisible}
        />
      )}
      {showCart && <SideBarCart onHide={editBag} getCartInfo={getCartInfo} />}
      {loading && <OverlayLoader isActive={loading} zIndex={2} message={loaderMessage} />}
    </>
  );
};

export default CheckoutPayment;
